'use strict';

const classNames = {
	trimEquipmentList: 'trim-equipment-list',
	filter: 'filter',
	heading: 'equipment__heading',
	listContainer: 'equipment__list-container'
};

const modifiers = {
	expanded: 'expanded'
};

export default {
	init: ($context) => {
		const $trimLevelsDropdown = $.findByBem(classNames.trimEquipmentList, classNames.filter, null, $context);
		if ($trimLevelsDropdown.length > 0) {
			$trimLevelsDropdown.off('change.equipmentList').on('change.equipmentList', () => {
				const selectedTrim = $trimLevelsDropdown.val();
				if (selectedTrim === '') {
					$.findByBem(classNames.trimEquipmentList, 'by-trim', null, $context).hide();
					$.findByBem(classNames.trimEquipmentList, 'optional', null, $context).fadeIn();
				} else {
					$.findByBem(classNames.trimEquipmentList, 'optional', null, $context).hide();
					$.findByBem(classNames.trimEquipmentList, 'by-trim', null, $context).hide().filter('[data-trim-id="' + selectedTrim + '"]').fadeIn();
				}
			});
		}

		const $equipmentListHeadings = $.findByBem(classNames.trimEquipmentList, classNames.heading, null, $context);
		$equipmentListHeadings.off('click.equipmentList').on('click.equipmentList', (event) => {
			const $heading = $(event.target).closestByBem(classNames.trimEquipmentList, classNames.heading);
			const $list = $heading.siblingsByBem(classNames.trimEquipmentList, classNames.listContainer);

			if ($list.length > 0) {
				$heading.toggleClass($.getBemClass(classNames.trimEquipmentList, classNames.heading, modifiers.expanded));
				$list.slideToggle(200);
			}
		});
	}
}